import { closeModal } from '@/helpers/closeModal';

export const closeSwipeAction = () => {
  // モバイル表示時のみ有効
  if (!window.storeeelItems.isMobile) return;

  // 下にスワイプでモーダルを閉じる
  const wrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .slide-media-wrapper');
  let threshold = 100;

  wrappers.forEach((wrapper) => {
    let startY = 0;
    let moveY = 0;
    let distance = 0;
    let startScrollTop = 0;
    let consumedPullDown = false;

    wrapper.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      // 計測開始時点のスクロール位置（ページが最上部か判定）
      const scrollingEl = document.scrollingElement || document.documentElement;
      startScrollTop = (scrollingEl && typeof scrollingEl.scrollTop === 'number') ? scrollingEl.scrollTop : (window.pageYOffset || 0);
      consumedPullDown = false;
    }, { passive: true });

    wrapper.addEventListener('touchmove', (e) => {
      moveY = e.touches[0].clientY;
      distance = moveY - startY;

      // ページ最上部での下方向スワイプ（いわゆるプル・トゥ・リフレッシュ）を抑止
      if (startScrollTop <= 0 && distance > 0) {
        e.preventDefault();
        consumedPullDown = true;
      }
    }, { passive: false });

    wrapper.addEventListener('touchend', (e) => {
      // 直前のtouchmoveでプルダウンを消費した場合は、既定動作（リロードなど）を抑止
      if (consumedPullDown) {
        e.preventDefault();
      }
      // SP + circle：下スワイプで閉じる（従来動作）
      if (window.storeeelItems.frame === 'circle') {
        if (distance > threshold) {
          closeModal();
        }
        return;
      }
      // SP + square：最初と最後でスワイプ方向を判定
      const slideEls = Array.from(document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide'));
      const currentSlide = wrapper.closest('.storeeel-swiper-group-wrapper .swiper-slide');
      const idx = slideEls.indexOf(currentSlide);
      const lastIdx = slideEls.length - 1;
      // 最初のスライド：下スワイプで閉じる
      if (idx === 0 && distance > threshold) {
        closeModal();
      }
      // 最後のスライド：上スワイプで閉じる
      if (idx === lastIdx && distance < -threshold) {
        closeModal();
      }
    }, { passive: false });
  });
}
